import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";
import checkAnswerFiles from "./checkAnswerFiles";
import { answerTypeMap } from "../../../constants/answerType";

const editAnswer = async (
	newAnswer,
	savedAnswer,
	questionId,
	order,
	answerType
) => {
	try {
		await client.put(
			`${uri}/item`,
			{
				Id: savedAnswer.id,
				QuestionId: questionId,
				TypeId: answerTypeMap[answerType],
				OrderNum: order,
				Name: newAnswer.text,
			},
			{
				headers: authHeader(),
			}
		);

		if (newAnswer.files || savedAnswer.files) {
			await checkAnswerFiles(savedAnswer, newAnswer);
		}
	} catch (e) {
		console.error(e);
		message.error(
			"Не получилось отредактировать вариант ответа, попробуйте позже"
		);
	}
};

export default editAnswer;
